function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

let fetchExactPrice = function (event) {
  event.preventDefault(); // Prevent the default link behavior

  const loaderIcon = document.querySelector('.loading-animation');
  const linkContainer = document.querySelector('.exact-pricing-container');
  const companyId = window.companyId;

  // Show the loader icon
  loaderIcon.style.display = 'inline-block';
  const currencySymbol = (document.querySelector('.price-item').textContent.trim()).slice(0,1);
  setTimeout(function() {
      const productId = window.productId;
      fetch(`/apps/pricing-api/customer-product-pricing?current_company_id=${companyId}&product_ids=${productId}`, {
          method: 'GET',
          headers: {
              'Content-Type': 'application/json',
          },
      })
          .then(response => response.json())
          .then(data => {
              // save pricing data to global variable so the variant switcher can access it
              window.showExactPrice = true;
              window.cql__ExactPricesList = data[0].variants.reduce((consolidatedVariants, variant) => {consolidatedVariants[variant.id] = variant.price; return consolidatedVariants}, {});
              const currentVariantId = document.querySelector('[name="id"]').value;

              // Process the pricing data here
              const exactPrice = currencySymbol + window.cql__ExactPricesList[currentVariantId].toString().trim();
              document.querySelector('.price-item').textContent = `${exactPrice}`;

              // Hide the exact pricing section (link, icon, and tooltip) once the price is updated
              loaderIcon.style.display = 'none';
              linkContainer.style.display = 'none';
          })
          .catch(error => {
              console.error('Error fetching pricing:', error);
              loaderIcon.style.display = 'none'; // Hide the loader icon if there's an error, but keep link visible
          });
  }, 1000);  // Delay of 1 second, adjust as needed
}

document.addEventListener('DOMContentLoaded', function () {
  const link = document.querySelector('.exact-pricing-link');

  link.addEventListener('click', fetchExactPrice);
});

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if(summary.hasAttribute('data-default-open')) {
    summary.click();
  }

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};
function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.plus = this.querySelector('[name=plus]');
    this.minus = this.querySelector('[name=minus]');
    this.variantIdField = this.closest('.product__info-container, .cart-item')?.querySelector("[name='id']");
    this.variantSelector = this.closest('.product__info-container')?.querySelector('variant-selects, variant-radios');
    this.changeEvent = new Event('change', { bubbles: true });

    this.increment = parseInt(this.input.getAttribute('increment')) || 1;
    this.input.addEventListener('change', this.updatePricing.bind(this));
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }
      
  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    event.target.name === 'plus' ? this.input.stepUp(this.increment) : this.input.stepDown(this.increment);
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

  }

  roundValue() {
    const min = parseInt(this.input.min) || this.increment;
    const max = parseInt(this.input.max);

    let roundedValue = Math.round(parseInt(this.input.value) / this.increment) * this.increment;
    if (roundedValue < min) roundedValue = min;
    if (roundedValue > max) roundedValue = max;

    if (roundedValue - this.increment < min) {
      this.minus.classList.add('disabled');
    } else {
      this.minus.classList.remove('disabled');
    }

    if (roundedValue + this.increment > max) {
      this.plus.classList.add('disabled');
    } else {
      this.plus.classList.remove('disabled');
    }

    this.input.value = roundedValue;
  }

  async updatePricing() {
    this.roundValue();
    if (!document.querySelector('body').classList.contains('site-winzeronesource')) {return;}
    if (!this.variantSelector) {return;}
    var price = document.querySelector(".price-item");
    let bulkInfo = this.variantSelector.bulkPrices;
    let quantity = this.input.value;

    if (!bulkInfo[this.variantIdField.value]) {
      price.classList.add('loading-price');
      this.variantSelector.updateBulkPricing();
    } else {
      let bulkPrices = bulkInfo[this.variantIdField.value];
      // console.log('bp', bulkPrices?.map((p) => `${p.quantity}: ${p.price}`).join(', '));
      price.classList.remove('loading-price');
      bulkPrices.forEach((item, index) => {
        if (quantity >= item.quantity) {
          price.innerText = "$" + item.price;
        }
      });
    }
  }

  /** Setting Quantity input to maximum product quantity on keyboard input **/
  // updateQtyMax() {
  //   let qtyMax = this.input.getAttribute("max");

  //   if (qtyMax != null && Number(this.input.value) > qtyMax) {
  //     this.input.value = (qtyMax != 0) ? qtyMax : 1;
  //   }
  // }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    document.body.dispatchEvent(new CustomEvent('modalOpened'));
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();

    if (this.classList.contains('autoplay')) {
      if (this.classList.contains('youtube')) {
        document.querySelector('.js-youtube').src += "&autoplay=1";
      } else {
        document.querySelector('.js-vimeo').src += "?autoplay=1";
      }
    }
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = this.sliderItemsToShow[this.sliderItemsToShow.length - 1];
    if (this.sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemsToShow[0].clientWidth);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderLastItem)) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderLastItem.clientWidth) : this.slider.scrollLeft - (step * this.sliderLastItem.clientWidth);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.bulkPrices = {};
    this.quantityInput = this.parentElement.querySelector('quantity-input');

    this.addEventListener('change', this.onVariantChange);
    this.additionalVariantData = JSON.parse(document.getElementById('additionalVariantData').textContent);
    this.updateOptions();
    this.updateMasterId();
    this.updateVariantMedia();
    this.addOutOfStockClass();
    this.updateBulkPricing();
  }

  onVariantChange(e) {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton();
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.removeColorVariantLabel();
    this.addOutOfStockClass();
    this.addClassToCustomElsforOutOfStock(!this.isCurrentVariantAvailable);
    this.updateCustomDynamicTexts();

    if (!this.currentVariant) {
      this.selectAvailableVariant(e.target);
      this.toggleAddButton();
    } else {
      if (window.cql__ExactPricesList?.[this.currentVariant.id]) {
        const input = document.getElementById("four_decimal_price");
        input.value = window.cql__ExactPricesList[this.currentVariant.id];
      }

      this.updateBulkPricing();
      this.updateMedia();
      this.updateVariantMedia();
      this.updateURL();
      this.updateVariantInput();
      this.updateMaxVariantQuantity();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    let swatches = this.querySelectorAll('input');

    if (swatches.length == 0) {
      this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    } else {
      this.inputs = Array.from(swatches).find((radio) => radio.checked).value;
      this.index = Number(document.querySelector('fieldset').getAttribute("node-index"));
      this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
      this.options.splice(this.index, 0, this.inputs)
    }
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });

    if (this.currentVariant) {
      this.lastValidVariant = this.currentVariant;
    }

    const increment = parseInt(this.currentVariant?.metafields?.minimum_order_quantity) || 1;
    const quantity = parseInt(this.additionalVariantData[this.currentVariant?.id]?.inventory) || 0;
    if (this.quantityInput) {
      this.quantityInput.increment = increment;
    }
    this.isCurrentVariantAvailable = quantity >= increment;
  }

  selectAvailableVariant(target) {
    let variants = this.getVariantData();
    const lastValidVariantIndex = variants.map(v => v.id).indexOf(this.lastValidVariant.id);

    function countOptionMatches(variant1, variant2) {
      let matches = 0;
      [1,2,3].forEach((i) => {
        if (variant1[`option${i}`] === variant2[`option${i}`]) matches++;
      });
      return matches;
    }

    // shift variants from before "lastValidVariant" to the end of the list to encourage moving "forward" down the list
    variants = [...variants.slice(lastValidVariantIndex), ...variants.slice(0, lastValidVariantIndex)];
    // bring up varaints that match the lastValidVariant's options to give them priority
    variants.sort((v1, v2) => {
      return countOptionMatches(v2, this.lastValidVariant) - countOptionMatches(v1, this.lastValidVariant);
    });

    const option = target.getAttribute('option');
    const value = target.getAttribute('value');
    // filter down the list to only variants that have the user's last selected option, keeping the sorted order
    const validVariants = variants.filter((variant) => variant[option] === value);

    if (validVariants.length) {
      // auto-select the first, highest priority validVariant
      this.querySelector('[option="option1"][value="'+validVariants[0].option1+'"]').checked = true;
      this.querySelector('[option="option2"][value="'+validVariants[0].option2+'"]').checked = true;
      if (this.querySelector("[option='option3'][value='"+validVariants[0].option3+"']")) this.querySelector("[option='option3'][value='"+validVariants[0].option3+"']").checked = true;

      this.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  addOutOfStockClass() {
    const variants = this.getVariantData();

    // get list of options & values that will map to the swatches
    function pairOptionValueWithPosition(variants, index) {
      // return empty array if isAllNull is true
      const isAllNull = variants.reduce((isAllNull, variant) => isAllNull && variant["option" + index] === null, true);
      // return list of unique values for this option
      return isAllNull ? [] : [...new Set(variants.map((variant) => {
        return variant["option" + index];
      }))].map((optionValue) => {
        // return object with both value and option position separately for use 
        return {
          position: "option" + index,
          value: optionValue
        };
      });
    }
    
    // compile options/values-to-swatch map in a single array of objects: {position: integer, value: "Value Here"}
    const options = [
      ...pairOptionValueWithPosition(variants, "1"),
      ...pairOptionValueWithPosition(variants, "2"),
      ...pairOptionValueWithPosition(variants, "3")
    ];

    options.forEach((option) => {
      const swatchElement = this.querySelector("[swatch='"+option.position+"__"+option.value+"']");

      // currently selected swatches are used as base for the option set
      let optionSet = {
        option1: this.querySelector('[option="option1"]:checked')?.value,
        option2: this.querySelector('[option="option2"]:checked')?.value,
        option3: this.querySelector('[option="option3"]:checked')?.value
      };
      // for each option (swatch) find the option set that WOULD be selected if that option/swatch were selected
      optionSet[option.position] = option.value;
      // find the variant for this hypothetical set of option selections; account porducts with no option2 / option3
      const swatchVariant = variants.filter((v) => {
        return v.option1 === optionSet.option1 && 
               (v.option2 === optionSet.option2 || optionSet.option2 === undefined) && 
               (v.option3 === optionSet.option3 || optionSet.option3 === undefined);
      })[0];

      if (swatchVariant) {
        swatchElement.classList.remove('strike-thru');
      } else {
        swatchElement.classList.add('strike-thru');
      }
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant?.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant?.featured_media?.id}`, true);
    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant?.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateVariantMedia() {
    let color_inputs = document.querySelectorAll("input[name=Color]");
    let color_dropdown = document.querySelectorAll("select[name='options[Color]']");
    let thumbs = document.querySelectorAll(".thumbnail-list__item img");
    let stackedThumbs = document.querySelectorAll(".product__media-item  img");

    if (color_inputs.length > 0 && false) { // this site doesn't have data for this color-image switching; so quickly disabling in case it needs undoing later
      color_inputs.forEach(i => {
        //Check if swatch input or dropdown
        if (i.checked) {
          if(thumbs.length > 0) {
            thumbs.forEach(t => {
              let searchValue = i.value.split(" ").join("-").toLowerCase();
              // console.log(searchValue)
              if(t.src.includes(searchValue)) {
                t.parentElement.parentElement.style.display = "block";
              } else {
                t.parentElement.parentElement.style.display = "none"
              }
            })
          }

          if (stackedThumbs.length > 0 ) {
            stackedThumbs.forEach(t => {
              let searchValue = i.value.split(" ").join("-").toLowerCase();
              // console.log(searchValue)
              if(t.src.includes(searchValue)) {
                t.parentElement.parentElement.parentElement.style.display = "block";
              } else {
                t.parentElement.parentElement.parentElement.style.display = "none"
              }
            })
          }
        }
      })
    } else {
        if (thumbs.length > 0) {
          thumbs.forEach(t => {
            if(color_dropdown[0] != null){
              let searchValue = color_dropdown[0].value.split(" ")[0].toLowerCase();
              if(t.src.includes(searchValue)) {
                t.parentElement.parentElement.style.display = "block";
              } else {
                t.parentElement.parentElement.style.display = "none"
              }
            }
          })
        }

        if (stackedThumbs.length > 0 ) {
          stackedThumbs.forEach(t => {
            if(color_dropdown[0] != null){
              let searchValue = color_dropdown[0].value.split(" ")[0].toLowerCase();
              if(t.src.includes(searchValue)) {
                t.parentElement.parentElement.style.display = "block";
              } else {
                t.parentElement.parentElement.style.display = "none"
              }
            }
          })
        }
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateMaxVariantQuantity() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantID = urlParams.get('variant');
    const qtyIncrement = parseInt(this.currentVariant.metafields.minimum_order_quantity) || 1;
    const variantData = this.additionalVariantData[variantID];
    const quantityInput = this.quantityInput?.input;
    const $incrementInformer = this.quantityInput?.parentNode.parentNode.querySelector('.increment-informer');

    if (quantityInput) this.quantityInput.increment = qtyIncrement;
    if ($incrementInformer) {
      $incrementInformer.querySelector('span').innerHTML = qtyIncrement;
      if (qtyIncrement == 1) {
        $incrementInformer?.classList.add('increment-1');
      } else {
        $incrementInformer?.classList.remove('increment-1');
      }
    }

    if (Number(quantityInput?.value) == 0) {
      quantityInput.value = 1;
    }

    //Check first if negative number
    if(Number(variantData?.inventory) >= qtyIncrement) {
      if(Number(quantityInput?.value) > Number(variantData.inventory)) {
        quantityInput.value = variantData.inventory;
        quantityInput.setAttribute('max', variantData.inventory);
      }
    }
    //If current inventory returns as negative, set the quantity value to 1
    //If its out of stock, the button will be disabled anyway
    //If it's negative but set to Not Track, setting to 1 will ensure they can still buy
    else if (Number(variantData.inventory) < 0) {
      quantityInput.value = 1;
    }

    if (quantityInput) {
      quantityInput.max = Math.floor(parseInt(variantData.inventory) / qtyIncrement) * qtyIncrement;
      quantityInput.min = qtyIncrement;

      this.quantityInput.input.value = qtyIncrement;
    }
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  fetchBulkPricing = (variantId) => {
    return fetch(`/apps/pricing-api/bulk-pricing?variant_ids=${variantId}`, {
      method: 'GET',
      headers: {
          'Content-Type': 'application/json',
      },
    })
    .then(response => response.json());
  }

  buildBulkPriceTable(variantBulkPricing) {
    const bulkPricingTableBody = document.getElementById('js-bulk-pricing-table');
    const bulkPricingHiddenElements = document.querySelectorAll('.js-bulk-pricing-hidden');

    if(variantBulkPricing?.length > 1) {
      // build and insert table
      bulkPricingTableBody.innerHTML = '';
      variantBulkPricing.forEach(item => {
        const row = document.createElement('tr');
        const quantityCell = document.createElement('td');
        const priceCell = document.createElement('td');

        quantityCell.textContent = item.quantity + '+';
        priceCell.textContent = '$' + item.price;

        row.appendChild(quantityCell);
        row.appendChild(priceCell);
        bulkPricingTableBody.appendChild(row);
      });

      // remove hidden classes
      bulkPricingHiddenElements.forEach(element => {
        element.classList.remove('hidden');
      });

    } else {
      // replace hidden classes
      bulkPricingHiddenElements.forEach(element => {
        element.classList.add('hidden');
      });
    }
  }

  updateBulkPricing = () => {
    if(window.Resources.shop_name.toLowerCase() === 'onesource') {
      const selectedVariantId = this.currentVariant?.id;
      const bulkPricingTableBody = document.getElementById('js-bulk-pricing-table');
      const bulkPricingHiddenElements = document.querySelectorAll('.js-bulk-pricing-hidden');
      const bulkPricingLoader = document.getElementById('js-bulk-pricing-loader-wrap');

      // reset table
      bulkPricingTableBody.innerHTML = '';
      
      if (this.bulkPrices[selectedVariantId]) {
        this.buildBulkPriceTable(this.bulkPrices[selectedVariantId]);
      } else {
        // show loader
        bulkPricingLoader.classList.add('show-loader');

        this.fetchBulkPricing(selectedVariantId).then(data => {
          const variantBulkPricing = data[0]?.quantity_breaks;
          this.bulkPrices[selectedVariantId] = variantBulkPricing;

          this.buildBulkPriceTable(variantBulkPricing);
          if (this.quantityInput) this.quantityInput.updatePricing(); // due to the asynchronous fetchBulkPricing; run this in case the info wasn't fetched in time for renderProductInfo
        })
        .catch(error => {
          // replace hidden classes
          bulkPricingHiddenElements.forEach(element => {
            element.classList.add('hidden');
          });

          console.error('Error fetching bulk pricing:', error);
        }).finally(() => {
          // hide loader
          bulkPricingLoader.classList.remove('show-loader');
        });
      }
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        // switch out variant price
        const priceDestination = document.getElementById(id);
        const priceSource = html.getElementById(id);

        // cql__ExactPricesList should contain the 4 digit price on B2B if it was loaded by the user
        if (window.cql__ExactPricesList?.[this.currentVariant.id] && window.showExactPrice) {
          const currencySymbol = (html.getElementById(id).querySelector('.price-item').textContent.trim()).slice(0,1);
          priceDestination.innerHTML = priceSource.innerHTML;
          priceDestination.querySelector('.price-item').innerHTML = currencySymbol + window.cql__ExactPricesList[this.currentVariant.id].toString().trim();
        } else {
          if (priceSource && priceDestination) priceDestination.innerHTML = priceSource.innerHTML;
        }

        // switch out variant attributes accordion
        const attributesDestination = document.querySelector('.attributes-json .accordion__content');
        const attributesSource = html.querySelector('.attributes-json .accordion__content');

        if (attributesSource && attributesDestination) attributesDestination.innerHTML = attributesSource.innerHTML;

        // switch out variant description accordion
        const descriptionDestination = document.querySelector('.product__accordion.description .accordion__content');
        const descriptionSource = html.querySelector('.product__accordion.description .accordion__content');

        if (descriptionSource && descriptionDestination) descriptionDestination.innerHTML = descriptionSource.innerHTML;

        // switch out exact pricing trigger button
        const exactPricingDestination = document.querySelector('.pdp__exact-pricing');
        const exactPricingSource = html.querySelector('.pdp__exact-pricing');

        if (exactPricingSource && exactPricingDestination && !window.cql__ExactPricesList) {
          exactPricingDestination.innerHTML = exactPricingSource.innerHTML;
          exactPricingDestination.addEventListener('click', fetchExactPrice);
        }

        // switch out variant warning badges
        const badgeDestination = document.querySelector('.product_messages_wrapper');
        const badgeSource = html.querySelector('.product_messages_wrapper');

        if (badgeSource && badgeDestination) {
          badgeDestination.innerHTML = badgeSource.innerHTML
        } else if (badgeDestination) {
          badgeDestination.innerHTML = ''; // necessary otherwise the last set of badges persists
        };

        this.quantityInput?.updatePricing();
        const price = document.getElementById(`price-${this.dataset.section}`);
        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(true);
      });

    this.switchVariantMetafieldDisplay('.product-lead-time', this.currentVariant.metafields.product_lead_time, `Ships in ${this?.currentVariant?.metafields?.product_lead_time} ${this?.currentVariant?.metafields?.product_lead_time > 1 ? "days" : "day"}`);
    this.switchVariantMetafieldDisplay('.pdp__price-promo-msg', this.currentVariant.metafields.promo_messaging);

  }

  switchVariantMetafieldDisplay(elSelector, field, message = false) {
    const el = this.parentElement.querySelector(elSelector)
    let displayMessage = message || field;

    if (el) {
      if (field) {
        el.innerHTML = displayMessage;
      } else {
        el.innerHTML = "";
      }
    }
  }

  toggleAddButton(isUpdateEnd = false) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addTextEl = addButton.querySelector('.js-add-btn-default');
    const outOfStockTextEl = addButton.querySelector('.js-add-btn-out-of-stock');
    const btnSpinner = addButton.querySelector('.js-add-btn-spinner');

    const currVariant = this.currentVariant;

    if (!addButton) return;

    if(!isUpdateEnd && currVariant) {
      addTextEl.classList.add('hidden');
      outOfStockTextEl.classList.add('hidden');
      btnSpinner.classList.remove('hidden');
    } else {
      btnSpinner.classList.add('hidden');

      if(!currVariant) {
        addTextEl.classList.add('hidden');
        outOfStockTextEl.classList.remove('hidden');
        outOfStockTextEl.innerHTML = window.variantStrings.unavailable;
        addButton.setAttribute('disabled','disabled');
      } else if (this.isCurrentVariantAvailable) {
        addTextEl.classList.remove('hidden');
        outOfStockTextEl.classList.add('hidden');
        addButton.removeAttribute('disabled');
      } else if (currVariant.price >= 1000000 || currVariant.price <= 0) {
        addTextEl.classList.add('hidden');
        outOfStockTextEl.classList.remove('hidden');
        outOfStockTextEl.innerHTML = window.variantStrings.unavailable;
        addButton.setAttribute('disabled','disabled');
      } else {
        addTextEl.classList.add('hidden');
        outOfStockTextEl.classList.remove('hidden');
        outOfStockTextEl.innerHTML = window.variantStrings.soldOut;
        addButton.setAttribute('disabled','disabled');
      }
    }
  }

  addClassToCustomElsforOutOfStock(isOutofStock) {
    const elementsToModify = document.querySelectorAll('.js-watch-variant-stock');
    elementsToModify.forEach(element => {
      if(isOutofStock) {
        element.classList.add('is-out-of-stock');
      } else {
        element.classList.remove('is-out-of-stock');
      }
    });
  }

  updateCustomDynamicTexts() {
    const selectedVariantId = this.escapeHtml(this.currentVariant?.sku);
    const currentVariantText = document.querySelectorAll('.js-current-variant-label');
    const itemNumberText = document.querySelector('.js-itemnum');
    const qtyMsgText = document.querySelector('.js-qty-msg');
    const currentVariantQty = Number(this.additionalVariantData[this.currentVariant?.id]?.inventory) ?? null;
    const lowStockThreshold = this.currentVariant?.metafields.low_inventory_quantity ? Number(this.currentVariant?.metafields.low_inventory_quantity) : null;
  
    currentVariantText.forEach((element, index) => {
      if (index < this.options.length) {
        element.textContent = this.options[index];
      }
    });
  
    if (itemNumberText) {
      itemNumberText.textContent = selectedVariantId;
    }
  
    if (qtyMsgText) {
      if (lowStockThreshold && currentVariantQty !== null && currentVariantQty > this.quantityInput.increment && currentVariantQty < lowStockThreshold) {
        qtyMsgText.classList.add("pdp__show-qty-msg");
      } else {
        qtyMsgText.classList.remove("pdp__show-qty-msg");
      }
    }
  }
  
  // Helper function to escape HTML special characters
  escapeHtml(unsafe) {
    return unsafe
      ?.replace(/&/g, "&amp;")
      ?.replace(/</g, "&lt;")
      ?.replace(/>/g, "&gt;")
      ?.replace(/"/g, "&quot;")
      ?.replace(/'/g, "&#039;");
  }
  
  setPriceLabelAddButton() {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    const button = productForm.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    let price = document.querySelector(".price-item").innerText;
    let hidePrice = document.querySelector("[data-hide-price]").dataset.hidePrice;
    
    if (button.hasAttribute('disabled')) {
      addButtonText.textContent = window.variantStrings.soldOut;
    } else {
      if(hidePrice != "true") {
        addButtonText.textContent = window.variantStrings.addToCart + " - " + price;
      }
    }
  }

  getVariantData() {
    let variantMetafields = JSON.parse(this.querySelector('.variant-cql-metafields-json[type="application/json"]').textContent)
    this.variantData = this.variantData || JSON.parse(this.querySelector('.variant-json[type="application/json"]').textContent).map((variant) => {
      variant.metafields = variantMetafields[variant.id];
      return variant;
    });

    return this.variantData;
  }

  removeColorVariantLabel() {
    let colorVariant = document.querySelector(".color__variant");
      if (colorVariant !== 'undefined' && colorVariant !== null) {
      colorVariant.remove()
    }
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

// TODO Move this to quantityInput
/** Setting Quantity input to maximum product quantity on keyboard input **/
const quantityInput = document.querySelector('.product input[name="quantity"]');
if (quantityInput) {
  quantityInput.addEventListener('change', function() {
  let qtyMax = quantityInput.getAttribute("max");
  if (qtyMax != null && Number(quantityInput.value) > qtyMax) {
    quantityInput.value = (qtyMax != 0) ? qtyMax : 1;
  }
})
};

/* Search Reset */
document.addEventListener('DOMContentLoaded', () => {
  let inputs = document.querySelectorAll('.search__input');
  let resets = document.querySelectorAll('.search__input-reset');

  inputs.forEach((input, id) => {
    input.addEventListener("keyup", (event) => {
      input.value != '' ? resets[id].classList.add('visible') : resets[id].classList.remove('visible');
    });
  });
  resets.forEach((reset, id) => {
    reset.addEventListener("click", () => {
      inputs[id].value = '';
      inputs[id].focus();
      resets[id].classList.remove('visible');
    });
  });
});
/* End Search Reset */

// TODO Fix errors Task: https://cqlcorp.atlassian.net/browse/CQLSTD-151
// class Accordion {
//   constructor(el) {
//     this.el = el;
//     this.summary = el.querySelector('summary');
//     this.content = el.querySelector('.accordion__content'); <-- Not all accordion content has this class. Causes errors on shop password, product, and possibly more.
//     this.animation = null;
//     this.isClosing = false;
//     this.isExpanding = false;
//     this.summary.addEventListener('click', (e) => this.onClick(e));
//   }

//   // Function called when user clicks on the summary
//   onClick(e) {
//     e.preventDefault();
//     this.el.style.overflow = 'hidden';
//     if (this.isClosing || !this.el.open) {
//       this.open();
//     } else if (this.isExpanding || this.el.open) {
//       this.close();
//     }
//   }

//   // Function called to close the content with an animation
//   close() {
//     this.isClosing = true;
//     const initialHeight = `${this.el.offsetHeight}px`;
//     const endHeight = `${this.summary.offsetHeight}px`;

//     if (this.animation) {
//       this.animation.cancel();
//     }

//     this.animation = this.el.animate({
//       height: [initialHeight, endHeight]
//     }, {
//       duration: 300,
//       easing: 'ease-out'
//     });

//     this.animation.onfinish = () => this.onAnimationFinish(false);
//     this.animation.oncancel = () => this.isClosing = false;
//   }

//   // Function called to open the element after click
//   open() {
//     this.el.style.height = `${this.el.offsetHeight}px`;
//     this.el.open = true;
//     window.requestAnimationFrame(() => this.expand());
//   }

//   // Function called to expand the content with an animation
//   expand() {
//     this.isExpanding = true;
//     const initialHeight = `${this.el.offsetHeight}px`;
//     const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

//     if (this.animation) {
//       this.animation.cancel();
//     }

//     this.animation = this.el.animate({
//       height: [initialHeight, endHeight]
//     }, {
//       duration: 300,
//       easing: 'ease-out'
//     });

//     this.animation = this.el.animate({
//       height: [initialHeight, endHeight]
//     }, {
//       duration: 300,
//       easing: 'ease-out'
//     });

//     this.animation = this.content.animate({
//       opacity: [0, 1]
//     }, {
//       duration: 300,
//       easing: 'ease-in'
//     });

//     this.animation.onfinish = () => this.onAnimationFinish(true);
//     this.animation.oncancel = () => this.isExpanding = false;
//   }

//   // Callback when the close or expand animations are done
//   onAnimationFinish(open) {
//     this.el.open = open;
//     this.animation = null;
//     this.isClosing = false;
//     this.isExpanding = false;
//     this.el.style.height = this.el.style.overflow = '';
//   }
// }

// // Instancing accoordions
// document.querySelectorAll('details').forEach((el) => {
//   new Accordion(el);
// });

// Fix for Toolbar z-indexes when modal open, we don't have access to the Slideout Component since its a Snap
document.addEventListener('DOMContentLoaded', function () {
  const filtersToggle = document.querySelector('.ss__button__filter-toggle');
  const slideout = document.querySelector('.ss__slideout');
  const overlay = document.querySelector('.ss__overlay');

  if (filtersToggle && slideout) {
    filtersToggle.addEventListener('click', function () {
    
      setTimeout(() => {
        if (slideout.classList.contains('ss__slideout--active')) {
          document.body.classList.add('filter-toolbar-open')
        } else {
          document.body.classList.remove('filter-toolbar-open');
        }
      }, 150);
    });
  }

  if (overlay) {
    overlay.addEventListener('click', function () {
      document.body.classList.remove('filter-toolbar-open');
    });
  }
});


